import React, { useEffect, useState } from "react";
import { getApiUrl } from "../utils/api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const Sampletext = () => {
  const [descriptions, setDescriptions] = useState([]);

  const fetchDescriptions = async () => {
    try {
      const res = await fetch(getApiUrl("advertisementdescription-list"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });
      const result = await res.json();
      if (result.success) {
        setDescriptions(result.data || []);
      }
    } catch (err) {
      toast.error("Failed to load advertisements");
    }
  };

  useEffect(() => {
    fetchDescriptions();
  }, []);

  return (
    <div className="add-container">
     <Swiper
  modules={[Autoplay, Navigation]}
  spaceBetween={20}
  slidesPerView={1}
  loop={true}
  autoplay={{
    delay: 4000, // ⬅ more time to read long text
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
  }}
  speed={800}
  navigation={false} // ❌ remove arrows (clean UI for mobile)
  grabCursor={true}
>
        {descriptions.length > 0 ? (
          descriptions.map((desc, index) => (
            <SwiperSlide key={`desc-${index}`}>
              <div className="ad-slide">
                <h4>{desc}</h4>
              </div>
            </SwiperSlide>
          ))
        ) : (
         
          Array(3).fill().map((_, index) => (
            <SwiperSlide key={`loading-${index}`}>
              <div className="ad-slide">
                <p>Loading ads...</p>
              </div>
            </SwiperSlide>
          ))
        )}
      </Swiper>
      <ToastContainer />
    </div>
  );
};

export default Sampletext;
